'use strict';

var PROTOCOL_RE = /^https?:\/\//;

function normalizeUrl(url, excludeProtocol) {
  if (!url) {
    return url;
  }

  if (!PROTOCOL_RE.test(url)) {
    url = `${window.location.protocol}//${url}`;
  }

  return excludeProtocol ?
    url.replace(PROTOCOL_RE, '') :
    url;
}

module.exports = normalizeUrl;


/** WEBPACK FOOTER **
 ** ./utils/normalizeUrl.js
 **/